import { FC, memo } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import { Button } from '@marriott/mi-ui-library';
import { StickyCtaProps } from './StickyCta.types';
import { StyledStickyCta } from './StickyCta.styles';

export const StickyCtaConfig = {
  emptyLabel: 'StickyCta',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/stickycta`,
};

export const StickyCtaComp: FC<StickyCtaProps> = memo((props: StickyCtaProps) => {
  const { linkText = '', linkUrl = '', openInaNewTab = 'false', trackingProperties } = props;

  const linkType = openInaNewTab === 'true' ? 'external' : 'internal';
  const targetAttribute = openInaNewTab === 'true' ? '_blank' : '_self';
  const ariaLabel = openInaNewTab === 'true' ? 'Open in new tab' : '';

  return (
    <StyledStickyCta data-testid="cobrand-StickyCta" data-component-name="o-cobrand-StickyCta" className="pt-2 pb-4">
      <Button
        isLink
        href={linkUrl}
        trackingProperties={trackingProperties}
        target={targetAttribute}
        className="m-button-s sticky_cta"
        linkType={linkType}
        buttonCopy={linkText}
        linkAriaLabelOpenNewWindow={ariaLabel}
      />
    </StyledStickyCta>
  );
});

StickyCtaComp.displayName = 'StickyCtaComp';

export const StickyCta = (props: StickyCtaProps) => {
  return (
    <EditableComponent config={StickyCtaConfig} {...props}>
      <StickyCtaComp {...props} />
    </EditableComponent>
  );
};
